import { Table, TableBody, TableContainer, TableHead, TableRow } from '@mui/material';
import { ActionTableColumnsType } from '../../../../../types/table/ActionTableColumnsType';
import { ActionTableSortParamsType } from '../../../../../types/table/ActionTableSortParamsType';
import TableColumns from '../TableColumns';
import styles from './styles.module.scss';

interface StyledTableleProps {
  columns: ActionTableColumnsType[];
  rows: React.ReactNode;
  sortParams: ActionTableSortParamsType;
  onClickHeader: (column: string) => void;
  onClickHeaderCheckbox?: () => void;
  selectAllState?: true | false | 'indeterminate';
}

export function TableRoot({
  columns,
  rows,
  sortParams,
  onClickHeader,
  onClickHeaderCheckbox,
  selectAllState,
}: StyledTableleProps) {
  return (
    <TableContainer className={styles.tableContainer}>
      <Table stickyHeader aria-label='simple table' className={styles.tableContent}>
        <colgroup>
          {/* checkbox行のwidthを固定 */}
          {columns.map(column => {
            if (column.key === 'checkbox') {
              return <col key={column.key} style={{ width: '120px' }} />;
            }
            return <col key={column.key} />;
          })}
        </colgroup>
        <TableHead>
          <TableRow>
            <TableColumns
              columns={columns}
              onClickHeader={onClickHeader}
              onClickHeaderCheckbox={onClickHeaderCheckbox}
              sortParams={sortParams}
              selectAllState={selectAllState}
            />
          </TableRow>
        </TableHead>
        <TableBody>{rows}</TableBody>
      </Table>
    </TableContainer>
  );
}
